import config from './config-dark';

export default config;
